import { createFileRoute } from '@tanstack/react-router';

import { conciliationListScreen, dataprevListSearch, loadConciliationMessages, loadConciliationScreens } from '@/modules/conciliation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/gestao-carteira/conciliacao/dataprev/')({
  validateSearch: dataprevListSearch,
  staticData: { screen: conciliationListScreen },
  loader: () => loadConciliationMessages(),
  component: lazyScreen(loadConciliationScreens, 'ConciliationListRouteScreen'),
});
